import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import ProjectItemService from "../services/ProjectItemService";
import Select from "react-select";

import ProjectService from "../services/ProjectService";
import StorageService from "../services/StorageService";
import ProjectStoreService from "../services/ProjectStoreService";
import ProjectLocationService from "../services/ProjectLocationService";
import StockIndentService from "../services/stockIndentService";
import StockInfoService from "../services/stockInfoService";
import MessageDialog from "../components/MessageDialog";

export default function AddStockIndent() {
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");

  const [projects, setProjects] = useState([]);
  const [stores, setStores] = useState([]);
  const [projectLocations, setProjectLocations] = useState([]);
  const [items, setItems] = useState([]);
  const [projectId, setProjectId] = useState("");

  const [projectFullData, setProjectFullData] = useState([]);
  const [categories, setCategories] = useState([]);

  const [indentItems, setIndentItems] = useState([
    { itemCategoryId: "", itemId: "", itemDescription: "", UOM: "", quantity: "", avalibleQty: 0, needByDate: "" },
  ]);

  const navigate = useNavigate();
  const { id } = useParams();

  const todayDate = new Date().toLocaleDateString("en-CA");

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      indentDate: todayDate,
    },
  });

  useEffect(() => {
    if (!id) {
      setValue("indentDate", todayDate);
    }
  }, [id, setValue, todayDate]);

  const formatQty3 = (val) => {
    if (val === null || val === undefined || val === "") return "0.000";
    return Number(val).toFixed(3);
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  const loadProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      if (
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        emp.roleName === "DataAdmin" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2
      ) {
        const res = await ProjectService.getActive(comp.companyId);

        projectsData = (res || []).map((p) => ({
          projectId: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode,
          projectCategoryName: p.categoryName || p.projectCategoryName,
        }));
      } else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map((p) => ({
          projectId: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode,
          projectCategoryName: p.categoryName || p.projectCategoryName,
        }));
      }

      setProjects(projectsData);
    } catch (err) {
      console.error("Error loading projects:", err);
      setProjects([]);
    }
  };

  const loadStores = async (pId) => {
    if (!pId) {
      setStores([]);
      return [];
    }
    try {
      const res = await ProjectStoreService.getProjectStoreById(pId);
      const list = res?.data || [];
      const filtered = list.filter((s) => String(s.projectId) === String(pId));
      setStores(filtered);
      return filtered;
    } catch {
      setStores([]);
      return [];
    }
  };

  const loadProjectFullData = async (pId) => {
    if (!pId) {
      setProjectFullData([]);
      setCategories([]);
      return [];
    }
    try {
      const res = await ProjectItemService.getProjectFullData(pId);
      const data = res?.data?.data || [];
      setProjectFullData(data);
      setCategories(data);
      return data;
    } catch (err) {
      console.error("Category load error", err);
      setProjectFullData([]);
      setCategories([]);
      return [];
    }
  };

  const loadProjectLocations = async (pId, storeId) => {
    if (!pId || !storeId) {
      setProjectLocations([]);
      setValue("locationId", "");
      return [];
    }

    try {
      const res = await ProjectLocationService.getByProjectAndStore(
        pId,
        storeId
      );

      const locs = res?.data || [];
      setProjectLocations(locs);
      return locs;
    } catch (err) {
      console.error("Location load error", err);
      setProjectLocations([]);
      return [];
    }
  };

  const handleCategoryChange = (index, categoryId) => {
    const updated = [...indentItems];
    updated[index].itemCategoryId = categoryId;
    updated[index].itemId = "";
    updated[index].itemDescription = "";
    updated[index].UOM = "";
    updated[index].avalibleQty = "0.000";
    setIndentItems(updated);
  };

  const getItemOptions = (categoryId) => {
    const cat = projectFullData.find(
      (c) => String(c.itemCategoryId) === String(categoryId)
    );

    if (!cat) return [];

    return (cat.items || []).map((i) => ({
      value: i.itemId,
      label: i.itemCode,
    }));
  };

  const fetchVoucherNo = async (pId, storeId) => {
    if (!pId || !storeId) {
      setValue("vocherNo", "");
      return;
    }

    try {
      const res = await StockIndentService.getVoucherNo(pId, storeId);
      setValue("vocherNo", res?.data?.voucherNo || "");
    } catch (err) {
      console.error("Voucher fetch error", err);
      setValue("vocherNo", "");
    }
  };

  const fetchAvailableQuantity = async (pId, storeId, itmId) => {
    const compId = StorageService.activeCompany()?.companyId;

    if (!compId || !pId || !storeId || !itmId) return 0;

    try {
      const res = await StockIndentService.getAvailableStock(
        compId,
        pId,
        storeId,
        itmId
      );

      return res?.data?.result?.quantity ?? 0;
    } catch (err) {
      console.error("Available qty fetch error", err);
      return 0;
    }
  };

  useEffect(() => {
    loadProjects();
    if (id) {
      setIsEdit(true);
      loadForEdit(id);
    }
  }, [id]);

  // Auto-select dropdowns if only 1 option is available
  useEffect(() => {
    if (projects.length === 1 && !isEdit) {
      const singleProj = projects[0];
      const pId = String(singleProj.projectId ?? singleProj.id);
      setValue("projectId", pId);
      setProjectId(pId);

      setValue("storeId", "");
      setValue("vocherNo", "");
      setItems([]);
      setIndentItems([
        { itemCategoryId: "", itemId: "", itemDescription: "", UOM: "", quantity: "", avalibleQty: "0.000", needByDate: "" }
      ]);
      loadStores(pId);
      setProjectLocations([]);
      setValue("locationId", "");
      loadItemsByProject(pId);
      loadProjectFullData(pId);
    }
  }, [projects, isEdit]);

  useEffect(() => {
    if (stores.length === 1 && !isEdit) {
      const singleStore = stores[0];
      const sId = String(singleStore.storeId ?? singleStore.id);
      setValue("storeId", sId);

      const pId = getValues("projectId");
      if (pId && sId) {
        fetchVoucherNo(pId, sId);
        loadProjectLocations(pId, sId);
      }
    }
  }, [stores, isEdit]);

  useEffect(() => {
    if (projectLocations.length === 1 && !isEdit) {
      const singleLoc = projectLocations[0];
      const locId = String(singleLoc.locationId ?? singleLoc.id);
      setValue("locationId", locId);
    }
  }, [projectLocations, isEdit]);

  const loadForEdit = async (editId) => {
    setEditLoading(true);
    try {
      const res = await StockIndentService.getById(editId);
      const payload = res?.data?.data || res?.data || {};
      const indent = payload.stockIndent || payload;

      if (!indent) return;

      if (indent.status && indent.status.toUpperCase() !== "PENDING") {
        showMessage("Only PENDING stock indents can be modified", "error");
        setTimeout(() => navigate("/cpnl/StockIndent/view"), 1500);
        return;
      }

      setValue("projectId", String(indent.projectId ?? ""));
      setValue("storeId", String(indent.storeId ?? ""));
      setValue("locationId", String(indent.locationId ?? ""));
      setValue("vocherNo", indent.vocherNo ?? "");
      setValue("stockIndentNotes", indent.stockIndentNotes ?? "");
      setValue(
        "indentDate",
        indent.indentDate
          ? new Date(indent.indentDate).toLocaleDateString("en-CA")
          : todayDate
      );

      let fullData = [];
      if (indent.projectId) {
        setProjectId(String(indent.projectId));
        await loadStores(indent.projectId);
        if (indent.storeId) {
          await loadProjectLocations(indent.projectId, indent.storeId);
        }
        await loadItemsByProject(indent.projectId);
        fullData = await loadProjectFullData(indent.projectId);
      }

      const details = payload.details || indent.details || [];
      const mappedDetails = [];

      for (const d of details) {
        let catId = d.itemCategoryId || "";
        if (!catId && fullData.length) {
          for (const cat of fullData) {
            const foundItem = (cat.items || []).find(
              (i) => String(i.itemId) === String(d.itemId)
            );
            if (foundItem) {
              catId = cat.itemCategoryId;
              break;
            }
          }
        }

        let avail = 0;
        if (indent.projectId && indent.storeId && d.itemId) {
          avail = await fetchAvailableQuantity(
            indent.projectId,
            indent.storeId,
            d.itemId
          );
        }

        let uomVal = d.UOM || d.uom || d.uomName || "";
        if (!uomVal || uomVal === "-") {
          const matchedItem =
            items.find((it) => String(it.id) === String(d.itemId)) ||
            items.find((it) => String(it.itemId) === String(d.itemId));
          if (matchedItem) {
            uomVal = matchedItem.uomName || matchedItem.uom || matchedItem.UOM || "";
          }
        }

        mappedDetails.push({
          itemCategoryId: catId ? String(catId) : "",
          itemId: String(d.itemId ?? ""),
          needByDate: d.needByDate ? new Date(d.needByDate).toLocaleDateString("en-CA") : "",
          itemDescription: d.itemDescription || d.itemName || "",
          UOM: uomVal,
          avalibleQty: formatQty3(avail),
          quantity: formatQty3(d.quantity),
          detailId: d.detailId || d.id,
        });
      }

      setIndentItems(
        mappedDetails.length
          ? mappedDetails
          : [{ itemCategoryId: "", itemId: "", itemDescription: "", UOM: "", quantity: "", avalibleQty: "0.000", needByDate: "" }]
      );
    } catch (err) {
      console.error("Edit load error", err);
      showMessage("Failed to load Stock Indent data", "error");
    } finally {
      setEditLoading(false);
    }
  };

  const loadItemsByProject = async (pId) => {
    if (!pId) {
      setItems([]);
      return;
    }

    try {
      const res = await ProjectItemService.getByProjectId(pId);
      const list = res?.data?.data || [];

      const mapped = list.map((x) => ({
        id: x.itemId,
        itemId: x.itemId,
        itemName: x.itemCode,
        itemDescription: x.itemDescription,
        uomName: x.uomName,
      }));

      setItems(mapped);
    } catch (err) {
      console.error("Project items load error", err);
      setItems([]);
    }
  };

  const handleAddRow = () => {
    setIndentItems([
      ...indentItems,
      { itemCategoryId: "", itemId: "", itemDescription: "", UOM: "", quantity: "", avalibleQty: "0.000", needByDate: "" },
    ]);
  };

  const hasDuplicateStockIndentItems = () => {
    const selectedItemIds = indentItems
      .map((r) => String(r.itemId).trim())
      .filter(Boolean);
    return selectedItemIds.length !== new Set(selectedItemIds).size;
  };

  const handleDeleteRow = (index) => {
    const updated = [...indentItems];
    updated.splice(index, 1);
    setIndentItems(updated);
  };

  const handleChange = async (index, field, value) => {
    if (
      field === "itemId" &&
      value &&
      indentItems.some(
        (row, rowIndex) => rowIndex !== index && String(row.itemId) === String(value)
      )
    ) {
      showMessage("This item is already selected in another row.", "error");
      return;
    }

    const updated = [...indentItems];
    updated[index][field] = value;

    if (field === "itemId") {
      let desc = "";
      let uom = "";

      const cat = projectFullData.find(
        (c) => String(c.itemCategoryId) === String(updated[index].itemCategoryId)
      );
      if (cat) {
        const itemObj = (cat.items || []).find(
          (i) => String(i.itemId) === String(value)
        );
        if (itemObj) {
          desc = itemObj.itemDescription || itemObj.itemName || "";
          uom = itemObj.uomName || itemObj.UOM || itemObj.uom || "";
        }
      }

      if (!desc || !uom) {
        const selectedItem =
          items.find((it) => String(it.id) === String(value)) ||
          items.find((it) => String(it.itemId) === String(value));
        if (selectedItem) {
          if (!desc) desc = selectedItem.itemDescription || selectedItem.itemName || "";
          if (!uom) uom = selectedItem.uomName || selectedItem.uom || selectedItem.UOM || "";
        }
      }

      updated[index].itemDescription = desc;
      updated[index].UOM = uom;
      updated[index].avalibleQty = "0.000";
      updated[index].quantity = "0.000";

      const storeId = Number(getValues("storeId"));
      const pId = Number(getValues("projectId"));

      if (storeId && pId && value) {
        try {
          const avail = await fetchAvailableQuantity(pId, storeId, Number(value));
          updated[index].avalibleQty = formatQty3(avail);
        } catch (err) {
          console.error("Stock info load error:", err);
          updated[index].avalibleQty = "0.000";
        }
      }
    }

    setIndentItems(updated);
  };

  const handleQuantityChange = (index, e) => {
    let value = e.target.value;

    if (value !== "" && !/^\d*\.?\d{0,3}$/.test(value)) return;

    setIndentItems((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        quantity: value,
      };
      return updated;
    });
  };

  const handleQuantityBlur = (index) => {
    setIndentItems((prev) => {
      const updated = [...prev];
      const val = updated[index].quantity;
      if (val !== "" && !isNaN(Number(val))) {
        updated[index].quantity = Number(val).toFixed(3);
      }
      return updated;
    });
  };

  const onSubmit = async (data) => {
    for (let i = 0; i < indentItems.length; i++) {
      if (!indentItems[i].itemId) {
        showMessage("Item is required for all rows", "error");
        return;
      }
      if (!indentItems[i].needByDate) {
        showMessage("Need By Date cannot be empty", "error");
        return;
      }
      const qty = parseFloat(indentItems[i].quantity);
      if (isNaN(qty) || qty <= 0) {
        showMessage("Quantity must be greater than zero for all rows", "error");
        return;
      }
    }

    if (hasDuplicateStockIndentItems()) {
      showMessage("Duplicate items are not allowed in Stock Indent details.", "error");
      return;
    }

    setLoading(true);

    const payload = {
      companyId: StorageService.activeCompany().companyId,
      projectId: Number(data.projectId),
      storeId: Number(data.storeId),
      locationId: data.locationId ? Number(data.locationId) : null,
      vocherNo: data.vocherNo,
      stockIndentNotes: data.stockIndentNotes || null,
      indentDate: data.indentDate,
      createdBy: StorageService.loginData().employeeId,
      updatedBy: StorageService.loginData().employeeId,
      details: indentItems.map((d) => ({
        itemId: Number(d.itemId),
        needByDate: d.needByDate,
        UOM: d.UOM,
        quantity: Number(parseFloat(d.quantity || 0).toFixed(3)),
        status: "Active",
        createdBy: StorageService.loginData().employeeId,
      })),
    };

    try {
      if (isEdit && id) {
        await StockIndentService.update(id, payload);
      } else {
        await StockIndentService.save(payload);
      }

      showMessage(`Stock Indent ${isEdit ? "updated" : "saved"} successfully!`, "success");
      setTimeout(() => navigate("/cpnl/StockIndent/view"), 1500);
    } catch (err) {
      console.error("Stock Indent save/update error:", err);

      const backendMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Error saving Stock Indent";

      showMessage(backendMessage, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/cpnl/StockIndent/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle={isEdit ? "Modify Stock Indent" : "Add Stock Indent"}
        secondTitle="Inventory"
      />

      <div className="card p-4 bg-white shadow-sm">
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />

        {editLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="mt-2 text-muted">Loading Stock Indent details...</div>
          </div>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            {/* ROW 1: Project & Store */}
            <div className="row">
              <div className="mb-3 col-md-6">
                <label className="form-label">
                Project Name <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("projectId", { required: "Project is required" })}
                onChange={(e) => {
                  const pId = e.target.value;

                  setProjectId(pId);
                  setValue("projectId", pId);

                  setValue("storeId", "");
                  setValue("vocherNo", "");

                  setItems([]);
                  setIndentItems([
                    { itemCategoryId: "", itemId: "", itemDescription: "", UOM: "", quantity: "", avalibleQty: "0.000", needByDate: "" },
                  ]);

                  loadStores(pId);
                  setProjectLocations([]);
                  setValue("locationId", "");
                  loadItemsByProject(pId);
                  loadProjectFullData(pId);
                }}
              >
                <option value="">Select Project</option>
                {projects.map((p) => (
                  <option key={p.projectId} value={p.projectId}>
                    {p.projectCategoryName
                      ? `${String(p.projectCategoryName).trim().charAt(0).toUpperCase()}*${p.projectName}`
                      : p.projectCode
                      ? `${String(p.projectCode).trim().charAt(0).toUpperCase()}*${p.projectName}`
                      : p.projectName}
                  </option>
                ))}
              </select>
              {errors.projectId && (
                <small className="text-danger">{errors.projectId.message}</small>
              )}
            </div>

            <div className="mb-3 col-md-6">
              <label className="form-label">
                Store <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("storeId", { required: "Store is required" })}
                onChange={(e) => {
                  const sId = e.target.value;
                  setValue("storeId", sId);

                  const pId = getValues("projectId");
                  if (pId && sId) {
                    if (!isEdit) fetchVoucherNo(pId, sId);
                    loadProjectLocations(pId, sId);
                  }
                }}
              >
                <option value="">Select Store</option>
                {stores.map((s) => (
                  <option key={s.storeId} value={s.storeId}>
                    {s.storeName}
                  </option>
                ))}
              </select>
              {errors.storeId && (
                <small className="text-danger">{errors.storeId.message}</small>
              )}
            </div>
          </div>

          {/* ROW 2: Location & Voucher */}
          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label">Location</label>
              <select
                className="form-select"
                {...register("locationId")}
                disabled={!getValues("storeId")}
              >
                <option value="">Select Location</option>
                {projectLocations.map((l) => (
                  <option key={l.locationId} value={l.locationId}>
                    {l.locationName}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3 col-md-6">
              <label className="form-label">Indent RequestNo</label>
              <input
                type="text"
                className="form-control"
                {...register("vocherNo")}
                readOnly
              />
            </div>
          </div>

          {/* ROW 3: Indent Date & Notes */}
          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label">
                Stock Indent Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                {...register("indentDate", {
                  required: "Indent Date is required",
                  validate: (value) => {
                    if (!value) return true;
                    const selected = value;
                    const today = new Date().toLocaleDateString("en-CA");
                    return selected <= today || "Indent Date cannot be a future date";
                  },
                })}
                onChange={(e) => {
                  const newDate = e.target.value;
                  setValue("indentDate", newDate);

                  const updated = indentItems.map((row) => ({
                    ...row,
                    needByDate: "",
                  }));
                  setIndentItems(updated);
                }}
              />
              {errors.indentDate && (
                <small className="text-danger">
                  {errors.indentDate.message}
                </small>
              )}
            </div>

            <div className="mb-3 col-md-6">
              <label className="form-label">Notes</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter notes"
                {...register("stockIndentNotes")}
              />
            </div>
          </div>

          <hr />
          <h5>Stock Indent Details</h5>
          <div
            className="table-responsive"
            style={{
              overflowX: "auto",
              ...(indentItems.length >= 4 ? { maxHeight: "280px", overflowY: "auto" } : {}),
            }}
          >
            <table className="table table-bordered mb-0" style={{ minWidth: "1530px" }}>
              <thead className="table-light sticky-top" style={{ zIndex: 2 }}>
                <tr>
                  <th style={{ minWidth: "290px" }}>Item Category</th>
                  <th style={{ minWidth: "370px" }}>Item</th>
                  <th style={{ minWidth: "140px" }}>Need By Date</th>
                  <th style={{ minWidth: "280px" }}>Item Description</th>
                  <th style={{ minWidth: "100px" }}>UOM</th>
                  <th style={{ minWidth: "130px" }}>Available Qty</th>
                  <th style={{ minWidth: "130px" }}>Quantity</th>
                  <th style={{ minWidth: "80px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {indentItems.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <Select
                        value={
                          categories
                            .map((c) => ({
                              value: c.itemCategoryId,
                              label: c.itemCategoryName,
                            }))
                            .find((opt) => String(opt.value) === String(row.itemCategoryId)) || null
                        }
                        onChange={(selected) =>
                          handleCategoryChange(index, selected ? selected.value : "")
                        }
                        options={categories.map((c) => ({
                          value: c.itemCategoryId,
                          label: c.itemCategoryName,
                        }))}
                        placeholder="Search Category..."
                        isClearable
                        menuPlacement="auto"
                        maxMenuHeight={150}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      />
                    </td>
                    <td>
                      <Select
                        value={
                          getItemOptions(row.itemCategoryId).find(
                            (o) => String(o.value) === String(row.itemId)
                          ) || null
                        }
                        onChange={(selected) =>
                          handleChange(index, "itemId", selected ? selected.value : "")
                        }
                        options={getItemOptions(row.itemCategoryId)}
                        placeholder="Search Item..."
                        isDisabled={!row.itemCategoryId}
                        isClearable
                        menuPlacement="auto"
                        maxMenuHeight={150}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        components={{ DropdownIndicator: null, IndicatorSeparator: null }}
                      />
                    </td>

                    <td>
                      <input
                        type="date"
                        className="form-control"
                        value={row.needByDate || ""}
                        onChange={(e) => {
                          const indentDate = getValues("indentDate");
                          const selected = e.target.value;

                          if (indentDate && selected < indentDate) {
                            showMessage(
                              "Need By Date must be greater than or equal to Stock Indent Date"
                            );
                            return;
                          }

                          handleChange(index, "needByDate", selected);
                        }}
                      />
                    </td>

                    <td>
                      <input
                        className="form-control fw-bold text-dark"
                        value={row.itemDescription || ""}
                        readOnly
                      />
                    </td>

                    <td>
                      <input
                        className="form-control fw-bold text-dark"
                        value={row.UOM || ""}
                        readOnly
                      />
                    </td>
                    <td>
                      <input
                        className="form-control fw-bold text-dark text-end"
                        value={row.avalibleQty || "0.000"}
                        readOnly
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control fw-bold text-dark text-end"
                        value={row.quantity ?? ""}
                        onChange={(e) => handleQuantityChange(index, e)}
                        onBlur={() => handleQuantityBlur(index)}
                        placeholder="0.000"
                      />
                    </td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-success btn-sm me-2"
                        onClick={handleAddRow}
                      >
                        +
                      </button>
                      {indentItems.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteRow(index)}
                        >
                          -
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-3">
            <button
              type="submit"
              className="btn btn-primary me-2"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {isEdit ? "Updating..." : "Saving..."}
                </>
              ) : (
                <>
                  <i className="ti ti-circle-check me-1"></i>
                  {isEdit ? "Update" : "Save"}
                </>
              )}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancel}
              disabled={loading}
            >
              <i className="ti ti-cancel me-1"></i>
              Cancel
            </button>
          </div>
        </form>
        )}
      </div>
    </>
  );
}
